package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ResetPasswordRequest(
    @SerialName("email") var email: String? = null,
    @SerialName("token") var token: String? = null,
    @SerialName("password") var hash: String? = null
)